import { useTranslation } from 'react-i18next'

import BellIcon from '@wwt/shared/assets/icons/outline/bell.svg'

import { Button, ButtonProps } from '@/shared/ui/Button'
import { UnderDevelopment } from '@/shared/ui/UnderDevelopment'

import { NotificationBadge } from './NotificationBadge.tsx'

export const NotificationsButton = (props: ButtonProps) => {
	const { t } = useTranslation('header')

	return (
		<UnderDevelopment asChild>
			<Button
				variant="tertiary"
				size="icon-sm"
				data-wwt-id="header__notifications--button"
				className="relative"
				{...props}
			>
				<BellIcon />
				<span className="sr-only">{t('notifications.open')}</span>
				<NotificationBadge />
			</Button>
		</UnderDevelopment>
	)
}
